import React, { FC } from 'react'
import RightArrow from '../../../assets/icons/RightArrow'
import styles from './index.module.scss'
import LeftArrow from '../../../assets/icons/LeftArrow'
import classNames from 'classnames'

export enum Scheme {
  Dark = 'Dark',
  Light = 'Light',
  Red = 'Red',
  Black = 'Black'
}

interface Props {
  newClassName: Scheme
  iconSize: 'small' | 'medium' | 'large'
  onClick?: () => void
  arrowDirection?: 'left' | 'right'
}
export const RoundIconButton: FC<Props> = ({
  newClassName,
  iconSize = 'medium',
  arrowDirection = 'right',
  ...props
}) => {
  const sizeStyle = `IconButton--${iconSize}`
  const iconFontMap = {
    small: 16,
    medium: 24,
    large: 56
  }
  const iconFontSize = iconFontMap[iconSize]
  return (
    <div
      aria-label="Go to another page"
      className={classNames(
        styles.RoundIconButton,
        styles[newClassName],
        styles[sizeStyle]
      )}
      role="button"
      {...props}
    >
      {arrowDirection === 'right' ? (
        <RightArrow height={`${iconFontSize}px`} width={`${iconFontSize}px`} />
      ) : (
        <LeftArrow height={`${iconFontSize}px`} width={`${iconFontSize}px`} />
      )}
    </div>
  )
}

RoundIconButton.defaultProps = {
  arrowDirection: 'right',
  onClick: () => null
}
